import "../../../vendor/js/waapi-animate-details";
(function ($, window, document) {
	//
	//
	//
	let gallery_block_extensions = {
		//
		_init: function () {
			//
			const $galleries = $(".wp-block-gallery");
			//
			const $images = $(".wp-block-gallery .wp-block-image");

			//
			$images.each(function () {
				//
				var imgAltAttr = $(this).find("img").attr("alt"); // we are using the alt-text because the title isnt working properly in our release

				if (imgAltAttr) {
					$(this)
						.find("figcaption")
						.prepend(
							"<span class='gallery-image-title'>" +
								imgAltAttr +
								"</span><br />"
						);
				}
			});
		},
	};
	//
	//
	//
	$(function () {
		//
		// 	?		extend all gallery blocks with some customizations
		//
		gallery_block_extensions._init();

		//
		// 	?		find any "magnific" galleries
		//
		// let mfp_gallery_blocks = $(".wp-block-gallery.js__magnific");
		let mfp_gallery_blocks = $(".wp-block-gallery");
		//
		for (let i = 0; i < mfp_gallery_blocks.length; i++) {
			//
			const thisGallery = mfp_gallery_blocks[i];
			//
			$(thisGallery).magnificPopup({
				delegate: ":not(.is-hidden) a", // the selector for gallery item
				type: "image",
				zoom: {
					enabled: true, // By default it's false, so don't forget to enable it
					duration: 300, // duration of the effect, in milliseconds
					easing: "ease-in-out", // CSS transition easing function
				},
				gallery: {
					enabled: true,
				},
				image: {
					titleSrc: function (item) {
						// clone the entire .wp-element-caption element (including the container)
						let value = item.el.next(".wp-element-caption").clone();
						// return the full caption, including the class, container and the styling
						return value;
					},
				},
			});
		}
		//
		//
		//
	});
	//
	//
	//
})(window.jQuery, window, document);
